import { render, staticRenderFns } from "./index_pc_component.vue?vue&type=template&id=42569b67&scoped=true&"
import script from "./index_pc_component.vue?vue&type=script&lang=js&"
export * from "./index_pc_component.vue?vue&type=script&lang=js&"
import style0 from "./index_pc_component.vue?vue&type=style&index=0&id=42569b67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42569b67",
  null
  
)

export default component.exports